<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">{{ $t("lang.msg.suppliers") }}</span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActive" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonAction @action="openCreateModal" color="gray" large>
          {{ $t('lang.msg.add') }}
        </ButtonAction>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openEditModal"
    />
    <TheModal
      :open="isModalOpen"
      @close="isModalOpen = false"
      :title="newItem.idSupplier == undefined ? $t('lang.msg.createRecord') : $t('lang.msg.updateRecord')"
    >
      <template #body>
        <form class="pt-3 space-y-4">
          <InputWrapper :label="$t('lang.fields.name')" content="input" block>
            <InputText v-model="newItem.supplierName" :name="$t('lang.fields.name')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.cif')" content="input" block>
            <InputText v-model="newItem.supplierCif" :name="$t('lang.fields.cif')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.address')" content="input" block>
            <InputText v-model="newItem.supplierDirection" :name="$t('lang.fields.address')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.location')" content="input" block>
            <InputText v-model="newItem.supplierUbication" :name="$t('lang.fields.location')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
            <InputText v-model="newItem.supplierPhone" :name="$t('lang.fields.phone')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.email')" content="input" block>
            <InputText v-model="newItem.supplierMail" :name="$t('lang.fields.email')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.anotations')" content="input" block>
            <textarea
              class="form-textarea w-full"
              v-model="newItem.supplierAnotation"
              :placeholder="$t('lang.fields.anotations')"
            />
          </InputWrapper>
          <AdminToggleButton v-model="newItem.active" />
        </form>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Suppliers/Add`, `api/Suppliers/Update`, true)"
          >{{ newItem.idSupplier == undefined ? $t('lang.msg.add') : $t('lang.msg.update') }}</button>
        </span>
      </template>
    </TheModal>
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import TheModal from "@/components/shared/TheModal";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Suppliers",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable,
    TheModal
  },
  data() {
    return {
      data: [],
      headers: {
        idSupplier: "#",
        supplierName: this.$t('lang.fields.name'),
        supplierCif: this.$t('lang.fields.cif'),
        supplierDirection: this.$t('lang.fields.address'),
        supplierUbication: this.$t('lang.fields.ubication'),
        supplierPhone: this.$t('lang.fields.phone'),
        supplierMail: this.$t('lang.fields.email'),
        active: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
    this.fetchData(`api/Suppliers/GetSupplier`);
  }
};
</script>
